module.exports = "pegasus/assets/blocks/image-3-theme2.png";